export default "__VITE_ASSET__BFmaiX1z__"